import { render, staticRenderFns } from "./DCard.vue?vue&type=template&id=718768f6&scoped=true&"
import script from "./DCard.vue?vue&type=script&lang=ts&"
export * from "./DCard.vue?vue&type=script&lang=ts&"
import style0 from "./DCard.vue?vue&type=style&index=0&id=718768f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718768f6",
  null
  
)

export default component.exports